(function () {
  var STORAGE_KEY = 'rochemara_recently_viewed';
  var MAX_STORED = 20;

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // localStorage indisponible (navigation privée, quota...) : on abandonne silencieusement.
    }
  }

  var dataTag = document.getElementById('RecentlyViewedProductData');
  if (!dataTag) return;

  var current;
  try {
    current = JSON.parse(dataTag.textContent);
  } catch (e) {
    return;
  }
  if (!current || !current.id) return;

  var list = getStored().filter(function (item) {
    return item && item.id !== current.id;
  });
  list.unshift(current);
  if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
  setStored(list);
})();
